export enum Launch_Ygg_Drasil {
  "pt-BR" = "pt-BR",
  es = "es",
  hu = "hu",
}
